import { api, transformResponse } from './axios'
import { FileData, DeleteFileData } from '../types/file'

export const updateFileData = (fileId: string, data: FileData, token: string) =>
  transformResponse(
    api.post(`/file/${fileId}`, data, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )

export const setFileDeletion = (data: DeleteFileData, token: string) => {
  return transformResponse(
    api.patch(
      `/file/${data.uuid}/deleted`,
      { isDeleted: data.isDeleted },
      {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      },
    ),
  )
}
